export default __webpack_public_path__ + "static/media/logo.4b3198c8.svg";